if (!window.Eurus.loadedScript.has('variant-select.js')) {
  window.Eurus.loadedScript.add('variant-select.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xVariantSelect', (
        element,
        sectionId,
        isProductPage,
        unavailableText,
        productUrl,
        cloneSectionId = element.closest('.data-id-section-card') ? element.closest('.data-id-section-card').id : ''
      ) => ({
        loadingEls: '',
        currentVariant: {},
        cachedResults: [],
        handleSectionId: sectionId,
        mediaGallerySource: [],
        optionConnects: [],
        mediaOption: "",
        handleSticky: '',
        initfirstMedia: false,
        _dispatchVariantSelected(html) {
          window.requestAnimationFrame(() => {
            setTimeout(() => { this.loadingEls = ''; }, 100);
          })
          document.dispatchEvent(new CustomEvent(`eurus:product-page-variant-select:updated:${sectionId}`, {
            detail: { html: html }
          }));
        },
        _dispatchUpdateVariant(html="") {
          document.dispatchEvent(new CustomEvent(`eurus:product-card-variant-select:updated:${sectionId}`, {
            detail: {
              currentVariant: this.currentVariant,
              html: html
            }
          }));
        },
        _renderDestination(html, selector) {
          const destination = document.getElementById(selector + sectionId);
          const source = html.getElementById(selector + sectionId);
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        _goToSelectedVariantMedia() {
          let splideEl = document.getElementById("x-product-" + sectionId);
          let slideVariant = ""
          let index = ""
          let activeEL = ""
          if (this.currentVariant !== undefined && this.currentVariant.featured_media !== undefined) {
            slideVariant = document.getElementsByClassName(this.currentVariant.featured_media.id + '-' + sectionId);
            index = parseInt(slideVariant[0]?.getAttribute('index'));
            activeEL = document.getElementById('postion-image-' + sectionId + '-' + this.currentVariant.featured_media.id);
          } else {
            slideVariant = splideEl.querySelector(".featured-image");
            index = parseInt(slideVariant?.getAttribute('index'));
            activeEL = document.querySelector(`#stacked-${sectionId} .featured-image`);
          }
          
          if (splideEl) {
            if (splideEl.splide && slideVariant) {
              splideEl.splide.go(index)
            } else {
              document.addEventListener(`eurus:media-gallery-ready:${sectionId}`, () => {
                if (splideEl.splide)
                  splideEl.splide.go(index);
              });
            }
          }

          return activeEL;
        },
        _updateMedia(html) {
          const quickViewRoot = element.closest('#QuickView');
          const scopeSelector = quickViewRoot ? '#QuickView' : `#shopify-section-${sectionId}`;
          let mediaWithVariantSelected = document.getElementById("product-media-" + sectionId) && document.getElementById("product-media-" + sectionId).dataset.mediaWithVariantSelected;
          const mediaMapEl = document.querySelector(`${scopeSelector} [data-variant-media-map]`);
          
          if (mediaMapEl) {
            this.updateMultiMediaWithVariant();
            return;
          }
          if (!mediaWithVariantSelected) {
            let activeEL = this._goToSelectedVariantMedia();
            if (!activeEL) return;

            if (html && !mediaWithVariantSelected) {
              let mediaGalleryDestination = html.getElementById(`stacked-${ sectionId }`);
              let mediaGallerySource = document.getElementById(`stacked-${ sectionId }`);

              if (mediaGallerySource && mediaGalleryDestination) {
                let firstChildSource = mediaGallerySource.querySelectorAll('div[data-media-id]')[0];
                let firstChildDestination = mediaGalleryDestination.querySelectorAll('div[data-media-id]')[0];
                if (firstChildDestination.dataset.mediaId != firstChildSource.dataset.mediaId && firstChildSource.dataset.index != 1) {
                  let sourceIndex = parseInt(firstChildSource.dataset.index);  
                  let positionOld = mediaGallerySource.querySelector(`div[data-media-id]:nth-of-type(${sourceIndex + 1})`);
                  mediaGallerySource.insertBefore(firstChildSource, positionOld);
                }

                mediaGallerySource.prepend(activeEL);
              }
            }
          }
          if (mediaWithVariantSelected) {
            this.updateMultiMediaWithVariant();
          }
        },
        _validateOption() {
          const mediaWithOption = document.querySelector(`#shopify-section-${sectionId} [data-media-option]`);
          if (mediaWithOption)
            this.mediaOption = mediaWithOption.dataset.mediaOption.split('_');
        },
        updateMultiMediaWithVariant() {
          if (!this.currentVariant) {
            if (this.initfirstMedia) {
              const quickViewRoot = element.closest('#QuickView');
              const scopeSelector = quickViewRoot ? '#QuickView' : `#shopify-section-${sectionId}`;
              let productMedia = document.querySelectorAll( `#ProductModal-${ sectionId } [data-media-option], ${scopeSelector} [data-media-option]`);
              Array.from(productMedia).reverse().forEach(function(newMedia, position) {
                newMedia.classList.add('media_active');
                if (newMedia.classList.contains('media-slide')) {
                  newMedia.classList.add('splide__slide');
                }
              });
            }
            return;
          }
          const quickViewRoot = element.closest('#QuickView');
          const scopeSelector = quickViewRoot ? '#QuickView' : `#shopify-section-${sectionId}`;
          const scopeRoot = quickViewRoot || document;
          const mediaMapEl = document.querySelector(`${scopeSelector} [data-variant-media-map]`);
          if (mediaMapEl && this.currentVariant?.id) {
            let mediaMap = null;
            try {
              mediaMap = JSON.parse(mediaMapEl.textContent);
            } catch (error) {
              console.warn('[variant-select] Failed to parse variant media map', error);
            }
            const variantId = this.currentVariant.id;
            const variantMediaList = (mediaMap?.[variantId] ?? mediaMap?.[String(variantId)]) || [];
            const productMedias = document.querySelectorAll(
              `#ProductModal-${ sectionId } .media-thumbnail[data-media-file],
               #ProductModal-${ sectionId } .media-slide[data-media-file],
               #ProductModal-${ sectionId } .product-media-item[data-media-file],
               #ProductModal-${ sectionId } .image-zoom[data-media-file],
               ${scopeSelector} .media-thumbnail[data-media-file],
               ${scopeSelector} .media-slide[data-media-file],
               ${scopeSelector} .product-media-item[data-media-file],
               ${scopeSelector} .image-zoom[data-media-file]`
            );
            if (productMedias.length) {
              const normalizeMediaUrl = (url) => {
                if (!url || typeof url !== 'string') return '';
                const s = url.trim();
                if (!s) return '';
                try {
                  const base = window.location.origin;
                  const href = s.startsWith('//') ? `${window.location.protocol}${s}` : s;
                  return new URL(href, base).pathname;
                } catch (error) {
                  return s.split('?')[0];
                }
              };
              let variantMediaKeys = Array.isArray(variantMediaList)
                ? variantMediaList.map((url) => normalizeMediaUrl(url))
                : [];
              const parentGroups = new Map();
              Array.from(productMedias).forEach((media) => {
                const parent = media.parentElement;
                if (!parent) return;
                const group = parentGroups.get(parent) || [];
                group.push(media);
                parentGroups.set(parent, group);
              });
              const featuredMediaId = this.currentVariant?.featured_media?.id
                ? `${sectionId}-${this.currentVariant.featured_media.id}`
                : null;
              if (featuredMediaId) {
                const featuredImage = this.currentVariant?.featured_image?.src;
                const featuredKey = normalizeMediaUrl(featuredImage);
                if (featuredKey && !variantMediaKeys.includes(featuredKey)) {
                  variantMediaKeys = [featuredKey, ...variantMediaKeys];
                }
              }
              const orderedMediaKeys = variantMediaKeys.length
                ? variantMediaKeys
                    .map((key) => key)
                    .filter(Boolean)
                : [];
              const allMediaEls = document.querySelectorAll(
                `#ProductModal-${ sectionId } .media-thumbnail,
                 #ProductModal-${ sectionId } .media-slide,
                 #ProductModal-${ sectionId } .product-media-item,
                 #ProductModal-${ sectionId } .image-zoom,
                 ${scopeSelector} .media-thumbnail,
                 ${scopeSelector} .media-slide,
                 ${scopeSelector} .product-media-item,
                 ${scopeSelector} .image-zoom`
              );
              allMediaEls.forEach((media) => {
                media.classList.remove('media_active');
                media.classList.remove('splide__slide');
                media.classList.remove('x-thumbnail');
              });
              let galleryOrderedIds = null;
              parentGroups.forEach((elements) => {
                const elementsByKey = new Map();
                elements.forEach((media) => {
                  const key = normalizeMediaUrl(media.dataset.mediaFile);
                  if (!key) return;
                  const group = elementsByKey.get(key) || [];
                  group.push(media);
                  elementsByKey.set(key, group);
                });
                const elementsById = new Map(
                  elements.map((media) => [media.dataset.mediaId, media])
                );
                let ordered = elements;
                if (orderedMediaKeys.length) {
                  ordered = [];
                  orderedMediaKeys.forEach((key) => {
                    const group = elementsByKey.get(key);
                    if (group && group.length) {
                      ordered = ordered.concat(group);
                      group.length = 0;
                    }
                  });
                }
                if (!ordered.length) {
                  ordered = elements;
                }
                if (featuredMediaId) {
                  const featuredMedia = elementsById.get(featuredMediaId);
                  if (featuredMedia) {
                    ordered = [featuredMedia, ...ordered.filter((media) => media !== featuredMedia)];
                  }
                }
                const uniqueOrdered = [];
                ordered.forEach((media) => {
                  if (!uniqueOrdered.includes(media)) {
                    uniqueOrdered.push(media);
                  }
                });
                if (galleryOrderedIds === null && uniqueOrdered.some((media) => media.classList.contains('media-slide'))) {
                  galleryOrderedIds = uniqueOrdered
                    .filter((media) => media.classList.contains('media-slide'))
                    .map((media) => media.dataset.mediaId)
                    .filter(Boolean);
                }
                Array.from(uniqueOrdered).reverse().forEach((media) => {
                  media.classList.add('media_active');
                  // Force-load the first lazy image on this slide immediately
                  const lazyImg = media.querySelector('img[loading="lazy"]');
                  if (lazyImg) lazyImg.loading = 'eager';
                  if (media.classList.contains('media-thumbnail')) {
                    media.classList.add('x-thumbnail');
                  }
                  if (media.classList.contains('media-slide')) {
                    media.classList.add('splide__slide');
                  }
                  const parent = media.parentElement;
                  if (parent && parent.firstChild !== media) {
                    parent.prepend(media);
                  }
                });
              });
              if (Array.isArray(galleryOrderedIds) && galleryOrderedIds.length) {
                const thumbRoot = scopeRoot.querySelector(`#x-product-thumbnail-${sectionId}`);
                if (thumbRoot) {
                  const thumbElements = Array.from(thumbRoot.querySelectorAll('.media-thumbnail'));
                  const thumbById = new Map(
                    thumbElements.map((media) => [media.dataset.mediaId, media])
                  );
                  const filteredThumbs = galleryOrderedIds
                    .map((id) => thumbById.get(id))
                    .filter(Boolean);
                  if (filteredThumbs.length) {
                    thumbElements.forEach((media) => {
                      media.classList.remove('media_active');
                      media.classList.remove('x-thumbnail');
                      media.classList.add('hidden');
                    });
                    Array.from(filteredThumbs).reverse().forEach((media) => {
                      media.classList.add('media_active');
                      media.classList.add('x-thumbnail');
                      media.classList.remove('hidden');
                      const parent = media.parentElement;
                      if (parent && parent.firstChild !== media) {
                        parent.prepend(media);
                      }
                    });
                  }
                }
              }
              let splideEl = scopeRoot.querySelector(`#x-product-${ sectionId }`);
              if (splideEl?.splide) {
                splideEl.splide.refresh();
                splideEl.splide.go(0);
              }
              let splideZoomEl = scopeRoot.querySelector(`#media-gallery-${ sectionId }`);
              if (splideZoomEl?.splide) {
                splideZoomEl.splide.refresh();
              }
              return;
            }
          }
          this._validateOption();
          const buyBoxContainer = element.closest('[data-buy-box-container]');
          const isBundleBuyBox = buyBoxContainer?.dataset?.isBundle === "true";
          const variantInputs = this.mediaOption.map(option =>
            element.querySelector(`[data-option-name="${option}"]`) ||
            document.querySelector(`#shopify-section-${sectionId} [data-option-name="${option}"]`)
          ).filter(el => el !== null);
          if (variantInputs.length === 0) {
            let variantMedias = ""
            if (!this.currentVariant?.featured_media?.id) {
              variantMedias = document.querySelectorAll(`#ProductModal-${ sectionId } [data-media-option].featured-image, #shopify-section-${ sectionId } [data-media-option].featured-image`); 
            } else {
              variantMedias = document.querySelectorAll(`#ProductModal-${ sectionId } [data-media-option="${sectionId}-${this.currentVariant?.featured_media?.id}"], #shopify-section-${ sectionId } [data-media-option="${sectionId}-${this.currentVariant?.featured_media?.id}"]`);
            }
            let mediaActive = document.querySelectorAll(`#ProductModal-${ sectionId } [data-media-option=""], #shopify-section-${ sectionId } [data-media-option=""]`);
            let productMedias = document.querySelectorAll( `#ProductModal-${ sectionId } [data-media-option], #shopify-section-${ sectionId } [data-media-option]`);
            const newMedias = Array.prototype.concat.call( ...mediaActive, ...variantMedias)
            this._setActiveMedia(productMedias, newMedias, variantMedias);

            let splideEl = document.getElementById(`x-product-${ sectionId }`);
            if (splideEl.splide) {
              splideEl.splide.refresh();
              splideEl.splide.go(0);
            }
            let splideZoomEl = document.getElementById(`media-gallery-${ sectionId }`);
            if (splideZoomEl.splide) {
              splideZoomEl.splide.refresh();
            }
          } else {
            let optionConnects = [];
            if (isBundleBuyBox) {
              const selectedInputs = Array.from(buyBoxContainer.querySelectorAll('fieldset input:checked'));
              optionConnects = selectedInputs
                .map((input) => this._handleText(input.value))
                .filter(Boolean);
            } else {
              variantInputs.forEach((variantInput) => {
                const variantOptionIndex = variantInput && variantInput.dataset.optionIndex;
                const optionValue = this._handleText(this.currentVariant?.options[variantOptionIndex]);
                if (this.mediaOption.includes(variantInput.dataset.optionName)) {
                  optionConnects.push(variantInput.dataset.optionName + '-' + optionValue);
                }
                this.optionIndex = variantOptionIndex;
              });
            }
            const mediaActive = document.querySelectorAll(`#ProductModal-${ sectionId } [data-media-type=""], #shopify-section-${ sectionId } [data-media-type=""]`);
            
            let variantMedias = [];
            let allVariantMedias = isBundleBuyBox
              ? document.querySelectorAll(`#ProductModal-${ sectionId } [data-media-type], #shopify-section-${ sectionId } [data-media-type]`)
              : document.querySelectorAll(`#ProductModal-${ sectionId } [data-media-type]:not([data-media-type=""]), #shopify-section-${ sectionId } [data-media-type]:not([data-media-type=""])`);
            allVariantMedias.forEach((variantMedia) => {
              let data = variantMedia.getAttribute('data-media-type') || '';
              let tokens = data ? data.split('_') : [];
              if (isBundleBuyBox) {
                const alt = variantMedia.querySelector('img')?.getAttribute('alt') || '';
                if (alt.includes('#')) {
                  tokens = alt
                    .split('#')
                    .pop()
                    .split('_')
                    .map((token) => this._handleText(token))
                    .filter(Boolean);
                }
              }
              let dataSet = new Set(tokens);
              // Match when all selected options are present, even if media has extra tags.
              if (optionConnects.every(option => dataSet.has(option))) {
                variantMedias.push(variantMedia);
              }
            });

            let showFeatured = false;
            if (!variantMedias.length) {
              if (!this.currentVariant?.featured_media?.id) {
                variantMedias = document.querySelectorAll(`#ProductModal-${ sectionId } [data-media-option].featured-image, #shopify-section-${ sectionId } [data-media-option].featured-image`); 
                showFeatured = true;
              } else {
                variantMedias = document.querySelectorAll(`#ProductModal-${ sectionId } [data-media-id="${sectionId}-${this.currentVariant?.featured_media?.id}"], #shopify-section-${ sectionId } [data-media-id="${sectionId}-${this.currentVariant?.featured_media?.id}"]`);
              }
            }
            if (!variantMedias.length) {
              document.querySelectorAll( `#ProductModal-${ sectionId } [data-media-type], #shopify-section-${ sectionId } [data-media-type]`).forEach(function(media){
                media.classList.add('media_active');
                media.classList.add('splide__slide');
              });
              let splideEl = document.getElementById(`x-product-${ sectionId }`);
              if (splideEl.splide) {
                splideEl.splide.refresh();
                splideEl.splide.go(0);
              }
              let splideZoomEl = document.getElementById(`media-gallery-${ sectionId }`);
              if (splideZoomEl.splide) {
                splideZoomEl.splide.refresh();
              }
              return;
            }
            
            const newMedias = Array.prototype.concat.call(...variantMedias , ...mediaActive);
            let productMedias = document.querySelectorAll( `#shopify-section-${ sectionId } [data-media-type], #ProductModal-${ sectionId } [data-media-type]`);
            
            this._setActiveMedia(productMedias, newMedias);
            
            if (this.optionConnect != optionConnects) {
              this.optionConnect = optionConnects;
            }
            
            let splideEl = document.getElementById(`x-product-${ sectionId }`);
            if (splideEl.splide) {
              splideEl.splide.refresh();
              splideEl.splide.go(0);
            }
            let splideZoomEl = document.getElementById(`media-gallery-${ sectionId }`);
            if(splideZoomEl && splideZoomEl.splide){
              splideZoomEl.splide.refresh();
            }
            
            if (showFeatured) {
              this._goToFirstSlide();
            }  
          }
        },
        _setActiveMedia(productMedias, newMedias, activeMedia) {
          productMedias.forEach(function(media){
            media.classList.remove('media_active');
            media.classList.remove('splide__slide');
            media.classList.remove('x-thumbnail');
          });
          Array.from(newMedias).reverse().forEach(function(newMedia, position) {
            newMedia.classList.add('media_active');
            // Force-load the first lazy image on this slide immediately
            const lazyImg = newMedia.querySelector('img[loading="lazy"]');
            if (lazyImg) lazyImg.loading = 'eager';
            if (newMedia.classList.contains('media-thumbnail')) {
              newMedia.classList.add('x-thumbnail');
            }
            if (newMedia.classList.contains('media-slide')) {
              newMedia.classList.add('splide__slide');
            }
            let parent = newMedia.parentElement;
            if (activeMedia) {
              if (parent.firstChild != newMedia && Array.from(activeMedia).includes(newMedia)) {
                parent.prepend(newMedia);
              }
            } else {
              if (parent.firstChild != newMedia) {
                parent.prepend(newMedia);
              }
            }
          });

          if (activeMedia) {
            let parent = activeMedia.parentElement;
            parent && parent.prepend(activeMedia);
          }
        },
        _handleText(someString) {
          if (someString) {
            return someString.toString().replace('ı', 'i').replace('ß', 'ss').normalize('NFC').replace('-', ' ').toLowerCase().trim().replace(/[^\p{L}\p{N}\s-]/gu, '').replace(/\s+/g, "-");
          }
        },
        _goToFirstSlide() {
          if (this.currentVariant && !this.currentVariant.featured_image) {
            let splideEl = document.getElementById("x-product-" + sectionId);
            if (splideEl) {
              if (splideEl.splide && this.currentVariant && this.currentVariant.featured_image != null) {
                splideEl.splide.go(0);
              }
            }

            let activeEL = document.querySelector(`#stacked-${sectionId} .featured-image`);
            let stackedEL = document.getElementById('stacked-' + sectionId);
            if(stackedEL && activeEL) stackedEL.prepend(activeEL);
          }
        },
        _updateProductForms() {
          const productForms = document.querySelectorAll(`#product-form-${sectionId}, #product-form-installment-${sectionId}, #product-form-sticky-${sectionId}`);
          productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            if (input) {
              input.value = this.currentVariant?.id;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        },
        _renderPriceProduct(html) {
          const destination = document.getElementById('price-' + sectionId);
          let source = html.getElementById('price-' + sectionId);
          if (!destination) return;
          if (!this.currentVariant) {
            destination.classList.add('hidden');
            return;
          } else {
            destination.classList.remove('hidden');
          }
          if(!source) {
            source = html.querySelector('.price');
            if (source && destination) destination.innerHTML = source.outerHTML;
          } else {
            if (source && destination) destination.innerHTML = source.innerHTML;
          }
        },
        _renderBuyButtons(html) {
          const productForms = document.querySelectorAll(`#product-form-${sectionId}, #product-form-installment-${sectionId}, #product-form-sticky-${sectionId}`);
          
          productForms.forEach((productForm) => {
            const atcSource = html.querySelector(`#${productForm.getAttribute("id")} .add_to_cart_button`);
            const atcDestination = productForm.querySelector('.add_to_cart_button');
            if (!atcDestination) return;

            if (atcSource && atcDestination) atcDestination.innerHTML = atcSource.innerHTML;
    
            if (this.currentVariant?.available) {
              /// Enable add to cart button
              atcDestination.dataset.available = "true";
              if (html.getElementById('form-gift-card-' + sectionId)) {
                if (document.getElementById('Recipient-checkbox-' + sectionId).checked && document.getElementById('recipient-form-' + sectionId).dataset.disabled == "true") {
                  atcDestination.setAttribute('disabled', 'disabled') 
                } else {
                  atcDestination.removeAttribute('disabled');
                }
              } else {
                atcDestination.removeAttribute('disabled');
              }
            } else {
              atcDestination.dataset.available = "false";
              atcDestination.setAttribute('disabled', 'disabled');
            }

            const cloneProductForms = document.querySelectorAll(`#product-form-${cloneSectionId}, #product-form-installment-${cloneSectionId}, #product-form-sticky-${cloneSectionId}`);
            cloneProductForms.forEach((cloneProductForm) => {
              if (cloneProductForm.getAttribute("id").includes(productForm.getAttribute("id"))){
                const atcCloneDestination = cloneProductForm.querySelector('.add_to_cart_button');
                if (!atcCloneDestination) return;

                if (atcSource && atcCloneDestination) atcCloneDestination.innerHTML = atcSource.innerHTML;
        
                if (this.currentVariant?.available) {
                  /// Enable add to cart button
                  atcCloneDestination.dataset.available = "true";
                  if (html.getElementById('form-gift-card-' + sectionId)) {
                    if (document.getElementById('Recipient-checkbox-' + sectionId).checked && document.getElementById('recipient-form-' + sectionId).dataset.disabled == "true") {
                      atcCloneDestination.setAttribute('disabled', 'disabled') 
                    } else {
                      atcCloneDestination.removeAttribute('disabled');
                    }
                  } else {
                    atcCloneDestination.removeAttribute('disabled');
                  }
                } else {
                  atcCloneDestination.dataset.available = "false";
                  atcCloneDestination.setAttribute('disabled', 'disabled');
                }
              }
            })

          });
          const paymentButtonDestination = document.getElementById('x-payment-button-' + sectionId);
          const paymentButtonSource = html.getElementById('x-payment-button-' + sectionId);
          if (paymentButtonSource && paymentButtonDestination) {
            if (paymentButtonSource.classList.contains('hidden')) {
              paymentButtonDestination.classList.add('hidden');
            } else {
              paymentButtonDestination.classList.remove('hidden');
            }
          }
        },
        _setMessagePreOrder(html) {
          const msg = document.querySelector(`.pre-order-${sectionId}`);
          if (!msg) return;
          msg.classList.add('hidden');
          const msg_pre = html.getElementById(`pre-order-${sectionId}`);
          if (msg_pre) {
            msg.classList.remove('hidden');
            msg.innerHTML = msg_pre.innerHTML;
          }
        },
        _setEstimateDelivery(html) {
          const est = document.getElementById(`x-estimate-delivery-container-${sectionId}`);
          if (!est) return;
          const est_res = html.getElementById(`x-estimate-delivery-container-${sectionId}`);
          if (est_res.classList.contains('disable-estimate')) {
            est.classList.add('hidden');
          } else {
            est.classList.remove('hidden');
            est.innerHTML = est_res.innerHTML;
          }

          const estimateDeliveryCart = document.querySelectorAll(`.cart-edt-${sectionId}`);
          const estimateDeliveryCartUpdate = html.querySelectorAll(`.cart-edt-${sectionId}`);
          if (estimateDeliveryCart.length > 0 && estimateDeliveryCartUpdate.length > 0) {
            estimateDeliveryCart.forEach((item, index) => {
              if(estimateDeliveryCartUpdate[index] != undefined && estimateDeliveryCartUpdate[index].innerHTML != undefined ){
                item.innerHTML = estimateDeliveryCartUpdate[index].innerHTML;
              }
            })
          }
        },
        _setMetafieldInfo(html, query) {
          const content_arr = document.querySelectorAll(`${query}-${sectionId}`);
          const content_res_arr = html.querySelectorAll(`${query}-${sectionId}`);       
          if (content_arr.length > 0 && content_res_arr.length > 0) {
            content_arr.forEach((toc, index) => {
              toc.innerHTML = content_res_arr[index].innerHTML;
            })
          }
        },
        _setBackInStockAlert(html) {
          const destination = document.getElementById(`back_in_stock_alert-${sectionId}`);
          const source = html.getElementById(`back_in_stock_alert-${sectionId}`);
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        _setPickupPreOrder(html) {
          const pickup = document.getElementById(`pickup-pre-order-${sectionId}`);
          if (!pickup) return;
          const pickup_res = html.getElementById(`pickup-pre-order-${sectionId}`);
          if (pickup_res.classList.contains('disable-pickup')) {
            pickup.classList.add('hidden');
          } else {
            pickup.classList.remove('hidden');
          }
        },
        _setUnavailable() {
          const selectors = ['price-sticky-', 'block-inventory-', 'x-badges-', 'pickup-', 'sku-', 'back_in_stock_alert-'];
          for (let selector of selectors) {
            const element = document.getElementById(selector + sectionId);
            if (element) element.classList.add('hidden');
          }
          
          const msg_pre = document.querySelector(`.pre-order-${sectionId}`);
          if (msg_pre) msg_pre.classList.add('hidden');
          const quantity = document.getElementById('x-quantity-' + sectionId);
          if (quantity) quantity.classList.add('unavailable');

          this._setBuyButtonUnavailable();
        },
        _setAvailable() {
          const selectors = ['block-inventory-', 'x-badges-', 'pickup-', 'sku-', 'back_in_stock_alert-'];
          for (let selector of selectors) {
            const element = document.getElementById(selector + sectionId);
            if (element) element.classList.remove('hidden');
          }
          const quantity = document.getElementById('x-quantity-' + sectionId);
          if (quantity) quantity.classList.remove('unavailable');
        },
        _setBuyButtonUnavailable() {
          const productForms = document.querySelectorAll(`#product-form-${sectionId},  #product-form-sticky-${sectionId}`);
          productForms.forEach((productForm) => {
            const addButton = productForm.querySelector('.add_to_cart_button');
            if (!addButton) return;
            addButton.setAttribute('disabled', 'disabled');
            const addButtonText = addButton.querySelector('.x-atc-text');
            if (addButtonText) addButtonText.textContent = unavailableText;
          });
        },
        initEventSticky() {
          document.addEventListener(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, (e) => {
            this.handleSticky = e.detail.variantElSticky;
            this.updateVariantSelector(-1, e.detail.targetUrl);
          });
        },
        _getCurrentVariant(html) {
          this.currentVariant = JSON.parse(html.querySelector(`script[type="application/json"][data-selected-variant]`).textContent);
        },
        updateVariantSelector(inputId, target) {
          let updateFullpage = false;
          let callback = () => {};
          
          const targetUrl = target || element.dataset.url;
          if (element.dataset.url !== targetUrl) {
            if (isProductPage) {
              updateFullpage = true;
            }
            callback = (html) => {
              this._getCurrentVariant(html);
              this._setAvailable();
              this._updateURL(targetUrl);
              this._handleSwapProduct(sectionId, html, updateFullpage);
              this._handleSwapQuickAdd(html);
              this._renderCardBundle(html);
              this._renderCardFBT(html);
              this._dispatchUpdateVariant(html);
              this._dispatchVariantSelected(html);
            };
          } else {
            callback = (html) => {
              this._getCurrentVariant(html);
              this._setAvailable();
              this._updateURL(targetUrl);
              this._updateProductForms();
              this._handleUpdateProductInfo(html);
              this._updateOptionValues(html);
              this._updateMedia(html);
              this._handleAvailable(html);
              this._dispatchUpdateVariant(html);
              this._dispatchVariantSelected(html);
            }
          }
          this._renderProductInfo(targetUrl, callback, updateFullpage);
        },
        _renderProductInfo(url, callback, updateFullpage) {
          let link = "";
          const selectedOptionValues = this._getSelectedOptionValues();
          let params = `option_values=${selectedOptionValues.join(',')}`;
          link = updateFullpage?`${url}?${params}`:`${url}?section_id=${this.handleSectionId}&${params}`;
          Alpine.store('xHelper').cancelRequest('eurus:product_info_request');
          if (this.cachedResults[link]) {
            const html = this.cachedResults[link];
            callback(html);
          } else {
            const controller = new AbortController();
            Alpine.store('xHelper').requestControllers.set('eurus:product_info_request', controller);
            fetch(link, { signal: controller.signal })
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                callback(html);
                this.cachedResults[link] = html;
              }).catch(err => {
                if (err.name !== 'AbortError') {
                  console.error(err);
                }
              })
          }
          this.handleSticky = '';
        },
        _handleUpdateProductInfo(html) {
          this._renderCardBundle(html);
          this._renderCardFBT(html);
          this._renderPriceProduct(html);
          const selectors = ['block-inventory-', 'block-available-quantity-', 'quantity-selector-', 'volume-', 'sku-', 'x-badges-', 'preorder-', 'cart-edt-'];
          for (let selector of selectors) {
            this._renderDestination(html, selector);
          }
          this._renderBuyButtons(html);
          this._setMessagePreOrder(html);
          this._setEstimateDelivery(html);
          
          const mtfSelectors = ['.properties_re_render', '.table_info_details', '.block-text', '.text-icon', '.collapsible-content', '.nutrition-bar-content', '.horizontab', '.featured-icon'];
          for (let selector of mtfSelectors) {
            this._setMetafieldInfo(html, selector);
          }
          this._setPickupPreOrder(html);
          this._setBackInStockAlert(html);
          Alpine.store('xUpdateVariantQuanity').render(html, this.handleSectionId);
          this._dispatchUpdateVariant(html);
          this._dispatchVariantSelected(html);
          this._updateOptionValues(html);
          Alpine.store('xPickupAvailable').updatePickUp(sectionId, this.currentVariant?.id);
        },
        initFirstAvailableVariant(el) {
          const selectedVariantEl = el.querySelector(`script[type="application/json"][data-selected-variant]`);
          if (selectedVariantEl) {
            this.currentVariant = JSON.parse(selectedVariantEl.textContent);
          }
          document.addEventListener('eurus:cart:items-changed', () => {
            this.cachedResults = [];
            Alpine.store('xUpdateVariantQuanity').updateQuantity(sectionId, productUrl, this.currentVariant?.id);
          });
          // Preload only the featured (first) image for each variant
          // so variant switches show the hero image instantly
          const preloadFeaturedImages = () => {
            const quickViewRoot = element.closest('#QuickView');
            const scopeEl = quickViewRoot || document.getElementById(`shopify-section-${sectionId}`);
            if (!scopeEl) return;
            const mediaMapEl = scopeEl.querySelector('[data-variant-media-map]');
            if (!mediaMapEl) return;
            let mediaMap;
            try { mediaMap = JSON.parse(mediaMapEl.textContent); } catch (e) { return; }
            const normalizeUrl = (url) => {
              if (!url || typeof url !== 'string') return '';
              try {
                const href = url.trim().startsWith('//') ? `${location.protocol}${url.trim()}` : url.trim();
                return new URL(href, location.origin).pathname;
              } catch (e) { return url.split('?')[0]; }
            };
            // Collect only the first (featured) URL from each variant
            const featuredKeys = new Set();
            Object.values(mediaMap).forEach(urls => {
              if (Array.isArray(urls) && urls.length > 0) {
                featuredKeys.add(normalizeUrl(urls[0]));
              }
            });
            // Find matching slide elements and switch their images to eager
            scopeEl.querySelectorAll('.media-slide[data-media-file]').forEach(slide => {
              const key = normalizeUrl(slide.dataset.mediaFile);
              if (featuredKeys.has(key)) {
                const img = slide.querySelector('img[loading="lazy"]');
                if (img) img.loading = 'eager';
              }
            });
          };
          if ('requestIdleCallback' in window) {
            requestIdleCallback(preloadFeaturedImages);
          } else {
            setTimeout(preloadFeaturedImages, 2000);
          }
          // Listen for bundle variant changes (form mode) to update media gallery with parent variant's media
          if (el.closest('[data-buy-box-container]')) {
            const self = this;
            document.addEventListener('buy-box:variant-changed', function bundleMediaHandler(e) {
              if (e.detail.isBundle && e.detail.sectionId === sectionId) {
                const prevVariantId = self.currentVariant?.id ?? null;
                if (e.detail.parentVariant) {
                  self.currentVariant = e.detail.parentVariant;
                } else {
                  // Fallback: use a minimal object so updateMultiMediaWithVariant
                  // doesn't bail at its null-check but skips the media-map path
                  // (id: null), allowing the DOM-based option-connects path to run.
                  self.currentVariant = { id: null };
                }
                const newVariantId = self.currentVariant?.id ?? null;
                // Only update the gallery when the variant selection actually changed;
                // skip for subscription/one-time toggles or quantity changes.
                if (newVariantId !== prevVariantId) {
                  self.updateMultiMediaWithVariant();
                }
              }
            });
          }
        },
        _handleAvailable(html) {
          const selectedVariant = html.querySelector('.variant-selects [data-selected-variant]')?.innerHTML;
          if (selectedVariant == 'null') {
            this._setUnavailable();
          }
        },
        _updateOptionValues(html) {
          if (element.dataset.buyBoxVariantSelects === "true") {
            return;
          }
          const variantSelects = html.querySelector('.variant-selects');
          if (variantSelects) {
            element.innerHTML = variantSelects.innerHTML;
            Alpine.initTree(element);
            Array.from(element.querySelectorAll('input')).forEach(input => {
              if (input.dataset.valueSelected === 'true') input.checked = true;
            });
          }
        },
        _getVariantData(inputId) {
          return JSON.parse(this._getVariantDataElement(inputId).textContent);
        },
        _getVariantDataElement(inputId) {
          return element.querySelector(`script[type="application/json"][data-resource="${inputId}"]`);
        },
        _updateURL(url) {
          if (!isProductPage) return;
          window.history.replaceState({}, '', `${url}${this.currentVariant?.id ? `?variant=${this.currentVariant?.id}` : ''}`);
        },
        _getSelectedOptionValues() {
          if (this.handleSticky == '') {
            return Array.from(element.querySelectorAll('select option[selected], fieldset input:checked')).map(
              (e) => e.dataset.optionValueId
            );
          } else {
            return Array.from(this.handleSticky.querySelectorAll('select option[selected]')).map(
              (e) => e.dataset.optionValueId
            );
          }
        },
        _renderCardBundle(html) {
          const destination = element.closest(".x-product-bundle-data");
          const card = html.getElementById('card-product-bundle-'+ this.handleSectionId);
          if (card) {
            const source = card.querySelector(".x-product-bundle-data");
            if (source && destination) destination.innerHTML = source.innerHTML;
          }
        },
        _renderCardFBT(html) {
          const destination = element.closest(".card-product-fbt");
          const source = html.querySelector('.card-product-fbt-clone .card-product-fbt');
          
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        _handleSwapProduct(sectionId, html, updateFullpage) {
          if (updateFullpage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
            const destination = document.querySelector('main');
            const source = html.querySelector('main');
            if (source && destination) destination.innerHTML = source.innerHTML;
          } else {
            const destination = document.querySelector('.x-product-' + sectionId);
            const source = html.querySelector('.x-product-' + sectionId);
            if (source && destination) destination.innerHTML = source.innerHTML;
          }
        },
        _handleSwapQuickAdd(html) {
          const destination = element.closest(".choose-options-content");
          const source = html.querySelector('.choose-options-content');
          if (source && destination) destination.innerHTML = source.innerHTML;
        }
      }))
    });
  });

  
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xPickupAvailable', {
        cachedResults: [],
        updatePickUp(id, variantId) {
          const container = document.getElementsByClassName('pick-up-'+ id)[0];
          if (!container) return;

          const link = window.Shopify.routes.root + `variants/${variantId}/?section_id=pickup-availability`;
          Alpine.store('xHelper').cancelRequest('eurus:pickup_availability_request');
          if (this.cachedResults[link]) {
            container.innerHTML = this.cachedResults[link].innerHTML;
          } else {
            const controller = new AbortController();
            Alpine.store('xHelper').requestControllers.set('eurus:pickup_availability_request', controller);
            fetch(link, { signal: controller.signal })
            .then(response => response.text())
            .then(text => {
              const pickupAvailabilityHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('.shopify-section');  
              this.cachedResults[link] = pickupAvailabilityHTML;
              container.innerHTML = pickupAvailabilityHTML.innerHTML;
            })
            .catch(e => {
              console.error(e);
            }); 
          }
        }
      });
    });
  });
  
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xUpdateVariantQuanity', {
        cachedResults: [],
        updateQuantity(sectionId, productUrl, currentVariant) {
          const quantity = document.getElementById('x-quantity-' + sectionId);
          const pricingPB = document.getElementById('x-pricing-progress-bar-' + sectionId);
          if (!quantity && !pricingPB) return;
          const url = currentVariant ? `${productUrl}?variant=${currentVariant}&section_id=${sectionId}` : `${productUrl}?section_id=${sectionId}`;
          Alpine.store('xHelper').cancelRequest('eurus:variant_quantity_request');
          if (this.cachedResults[url]) {
            this.render(this.cachedResults[url], sectionId);
          } else {
            const controller = new AbortController();
            Alpine.store('xHelper').requestControllers.set('eurus:variant_quantity_request', controller);
            fetch(url, { signal: controller.signal })
              .then((response) => response.text())
              .then((responseText) => {
                let html = new DOMParser().parseFromString(responseText, 'text/html');
                this.cachedResults[url] = html;
                this.render(html, sectionId);
              });
          }
        },
        render(html, sectionId) {
          const destination = document.getElementById('x-quantity-' + sectionId);
          const source = html.getElementById('x-quantity-'+ sectionId);
          if (source && destination) destination.innerHTML = source.innerHTML;

          const destinationPricingPB = document.getElementById('x-pricing-progress-bar-' + sectionId);
          const sourcePricingPB = html.getElementById('x-pricing-progress-bar-' + sectionId);
          if (sourcePricingPB && destinationPricingPB) destinationPricingPB.innerHTML = sourcePricingPB.innerHTML;     
        }
      });
    });
  });
}